import Header from "./Header";
import Footer from "./Footer";
import "../../styles/Layout.css";

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <main className="layout-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
